import axios from "axios";

const BUSINESS_LOOKUP_URL = "https://api.xinvoice.vn/gdt-api/tax-payer";

export const normalizeBusinessTaxCode = (value) => {
  const taxCode = String(value ?? "").trim();
  if (!/^\d{10}(?:-?\d{3})?$/.test(taxCode)) {
    throw new Error("MST doanh nghiệp phải gồm 10 số hoặc 13 số (có thể có dấu - trước 3 số cuối).");
  }
  return taxCode.length === 13
    ? `${taxCode.slice(0, 10)}-${taxCode.slice(10)}`
    : taxCode;
};

export const lookupBusinessByTaxCode = async (value) => {
  const taxCode = normalizeBusinessTaxCode(value);
  let result;
  try {
    const response = await axios.get(
      `${BUSINESS_LOOKUP_URL}/${encodeURIComponent(taxCode)}`,
      { timeout: 10000 },
    );
    result = response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error("Không tìm thấy doanh nghiệp theo MST này.");
    }
    if (error.response?.status === 400) {
      throw new Error("Mã số thuế không hợp lệ.");
    }
    if (error.response?.status === 429) {
      throw new Error("Dịch vụ tra MST đang quá tải. Vui lòng thử lại sau.");
    }
    throw new Error("Không thể kết nối dịch vụ tra MST. Vui lòng thử lại hoặc nhập thông tin thủ công.");
  }

  if (result?.success === false) {
    throw new Error(
      typeof result.message === "string" && result.message.trim()
        ? result.message.trim()
        : "Không tìm thấy doanh nghiệp theo MST này.",
    );
  }

  if (
    typeof result?.name !== "string" ||
    !result.name.trim() ||
    String(result.taxID).replace(/-/g, "") !== taxCode.replace(/-/g, "")
  ) {
    throw new Error("Dịch vụ tra MST trả về thông tin không hợp lệ.");
  }

  return {
    taxCode,
    name: result.name.trim(),
    address: typeof result.address === "string" ? result.address.trim() : "",
  };
};
